import { Box, BoxProps, Stack } from "@mui/material"
import HomePageHeader from "../../components/Header/HomePageHeader"
import { DAMS_PAGE_TOP_BAR_HEIGHT } from "../../components/styles/common"
import AddItemPageHeader from "../../components/Header/AddItemPageHeader"
import { DamsBasePageProps } from "."
import DamsPageHeaderProps from "../../components/Header"


function MainPageBase({
    children,
    pageState = 'main',
    title,
    subtitle,
    
    addItemBtnOnClick,
    addItemBtnText,

    exportBtnOnClick,
    exportBtnText,

    columnsBtnOnClick,
    columnsBtnText,

    filterBtnOnclick,
    filterBtnText, 

    searchBtnOnClick,
    searchBtnText, 

    cancelBtnClick,
    cancelBtnText,

    proceedBtnClick,
    proceedBtnText,
    extraComponent
}: BoxProps & DamsBasePageProps & DamsPageHeaderProps) {
    return (
        <Box
            flexGrow={1}
            height={'100%'}
            width={'100%'}
        >
            {/* Page Header  */}
            <Stack height={DAMS_PAGE_TOP_BAR_HEIGHT}>
                {pageState === 'add-item'
                    ? (
                        <AddItemPageHeader
                            title={title}
                            subtitle={subtitle}
                            addItemBtnOnClick={addItemBtnOnClick}
                            cancelBtnClick={cancelBtnClick}
                        />
                    )
                    : (
                        <HomePageHeader
                            title={title}
                            subtitle={subtitle}
                            addItemBtnOnClick={addItemBtnOnClick}
                            addItemBtnText={addItemBtnText}
                            columnsBtnOnClick={columnsBtnOnClick}
                            columnsBtnText={columnsBtnText}
                            filterBtnOnclick={filterBtnOnclick}
                            filterBtnText={filterBtnText}
                            searchBtnOnClick={searchBtnOnClick}
                            searchBtnText={searchBtnText}
                            exportBtnOnClick={exportBtnOnClick}
                            exportBtnText={exportBtnText}
                            proceedBtnClick={proceedBtnClick}
                            proceedBtnText={proceedBtnText}
                            extraComponent={extraComponent}
                        />
                    )
                }

            </Stack>

            {/* Page Content */}
            <Box
                height={`calc(100% - ${DAMS_PAGE_TOP_BAR_HEIGHT}px)`}
                width={'100%'}
                // border={'1px solid orange'}
                pb={4}
                pr={4}
                pl={4}
            >
                {children}
            </Box>
        </Box>
    )

}



export { MainPageBase }
